module.exports = __webpack_public_path__ + "img/Hadoop-Model.452114db.png";